import { render } from "./Menu.vue?vue&type=template&id=28354edb&scoped=true&bindings={}"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"

import "./Menu.vue?vue&type=style&index=0&id=28354edb&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-28354edb"

export default script